import {
  type FC
} from 'react';
import {
  GlobalStyles
} from '@mui/joy';
import {
  alpha
} from '@mui/system';

export const OverriddenRewardPopupStyles: FC = () => (
  <GlobalStyles
    styles={({ breakpoints, palette }) => ({
      '#fasttrack-crm .inbox-wrapper .inbox': {
        width: 358,
        borderRadius: 12,
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: palette.common[925],
        background: palette.common[475],
        boxShadow: `0px 0px 16px 0px ${alpha(palette.common[350], 0.8)}`
      },
      [breakpoints.down(768)]: {
        '#fasttrack-crm .inbox-wrapper .inbox': {
          height: 'fit-content',
        }
      },
      '#fasttrack-crm .inbox-wrapper .close-btn': {
        marginRight: 28,
        marginTop: 24,
        boxShadow: 'none',
        transition: 'none',
        backgroundColor: 'transparent',
        '&:hover': {
          transform: 'none',
        }
      },
      '#fasttrack-crm .inbox-wrapper .close-btn::before,#fasttrack-crm .inbox-wrapper .close-btn::after': {
        content: "''",
        position: 'absolute',
        top: '50%',
        left: '50%',
        width: 20,
        height: 2,
        backgroundColor: palette.common[200],
      },
      '#fasttrack-crm .inbox-wrapper .inbox .selected-message': {
        rowGap: 24,
        minHeight: 'unset',
        background: 'transparent',
        justifyContent: 'space-between',
      },
      '#fasttrack-crm .inbox-wrapper .inbox .selected-message .image': {
        order: 2,
        paddingInline: 24,
        overflow: 'hidden',
        background: 'transparent',
        justifyContent: 'space-between',
      },
      '#fasttrack-crm .inbox-wrapper .inbox .selected-message .image img': {
        borderRadius: 8,
        background: 'transparent',
      },
      '#fasttrack-crm .inbox-wrapper .inbox .selected-message .scroll-area': {
        order: 1,
        flexGrow: 'unset',
        paddingInline: 24,
        paddingBoxStart: 24,
        paddingBlockStart: 24
      },
      '#fasttrack-crm .inbox-wrapper .inbox .selected-message .scroll-area .title': {
        color: palette.common[825],
        fontSize: 20,
        fontStyle: 'normal',
        fontWeight: 600,
        lineHeight: '30px',
        margin: 0,
        paddingBottom: 12,
      },
      '#fasttrack-crm .inbox-wrapper .inbox .selected-message .scroll-area .message-body': {
        fontSize: 14,
        fontWeight: 400,
        color: palette.common[150],
        lineHeight: '20px',
        fontStyle: 'normal',
        margin: 0,
      },
      '#fasttrack-crm .inbox-wrapper .inbox .selected-message .scroll-area .bottom-info': {
        display: 'none'
      },
      '#fasttrack-crm .inbox-wrapper .inbox .selected-message .bottom-row': {
        order: 3,
        padding: 0,
        boxShadow: 'none',
        paddingInline: 24,
        paddingBlockEnd: 24
      },
      '#fasttrack-crm .inbox-wrapper .inbox .selected-message .bottom-row .buttons-row': {
        margin: 0,
      },
      '#fasttrack-crm .inbox-wrapper .inbox .selected-message .bottom-row .buttons-row .cta-button': {
        margin: 0,
        '--Icon-margin': 'initial',
        '--Icon-color': 'currentColor',
        '-webkit-tap-highlight-color': 'transparent',
        boxSizing: 'border-box',
        border: 'none',
        cursor: 'pointer',
        userSelect: 'none',
        display: 'inline-flex',
        '-webkit-box-align': 'center',
        alignItems: 'center',
        '-webkit-box-pack': 'center',
        justifyContent: 'center',
        position: 'relative',
        textDecoration: 'none',
        fontFamily: 'var(--joy-fontFamily-body)',
        lineHeight: 'var(--joy-lineHeight-md)',
        height: 40,
        width: '100%',
        '--variant-borderWidth': '0px',
        color: `var(--variant-solidColor, var(--joy-palette-success-solidColor, var(--joy-palette-common-white, ${palette.common.white})))`,
        backgroundColor: 'var(--variant-solidBg, var(--joy-palette-success-solidBg, var(--joy-palette-success-500, #1F7A1F)))',
        borderRadius: '8px',
        '--Icon-fontSize': '2rem',
        '--Button-gap': '1rem',
        paddingBlock: '0.625rem',
        paddingInline: '1.5rem',
        fontSize: '1rem',
        fontWeight: 'var(--joy-fontWeight-xl, 600)',
        boxShadow: `${alpha(palette.common.white, 0.3)} 0px 4px 2px 0px inset, ${alpha('#12C57E', 0.3)} 0px 3px 16px 0px`,
      },
      '#fasttrack-crm .inbox-wrapper .inbox .selected-message .bottom-row .buttons-row .cta-button.secondary': {
        backgroundColor: 'var(--variant-solidBg, var(--joy-palette-primary-solidBg, var(--joy-palette-primary-500, #0B6BCB)))',
      },
    })}
  />
);